import React, { useState, useEffect } from 'react';
import { Clock } from 'lucide-react';

const DateTimeDisplay = ({ theme, language, isMobile, isTablet }) => {
  const [currentTime, setCurrentTime] = useState(new Date());

  // Get timezone from browser
  const getTimezoneAbbr = () => {
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZoneName: 'short',
    });
    const parts = formatter.formatToParts(new Date());
    const timeZoneName = parts.find((part) => part.type === 'timeZoneName');
    return timeZoneName ? timeZoneName.value : '';
  };

  // Update time every second
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  // Format date and time based on language
  const formatDateTime = () => {
    const options = {
      weekday: language === 'ar' ? 'long' : 'short',
      year: 'numeric',
      month: language === 'ar' ? 'long' : 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: language === 'ar' ? false : true,
    };

    if (language === 'ar') {
      return currentTime.toLocaleDateString('ar-EG', options);
    }
    return currentTime.toLocaleDateString('en-US', options);
  };

  const timezoneName = getTimezoneAbbr();

  // Responsive styles
  const getDisplayStyle = () => {
    // Hide on very small screens (less than 640px)
    if (isMobile && window.innerWidth < 640) {
      return { display: 'none' };
    }

    return {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '0.5rem',
      padding: isMobile ? '0.4rem 0.6rem' : isTablet ? '0.5rem 0.75rem' : '0.6rem 1rem',
      background: theme === 'dark'
        ? 'rgba(255, 255, 255, 0.05)'
        : 'rgba(59, 130, 246, 0.05)',
      border: theme === 'dark'
        ? '1px solid rgba(255, 255, 255, 0.1)'
        : '1px solid rgba(59, 130, 246, 0.2)',
      borderRadius: '0.875rem',
      fontSize: isMobile ? '0.7rem' : isTablet ? '0.75rem' : '0.8rem',
      color: theme === 'dark' ? 'rgba(255, 255, 255, 0.8)' : 'rgba(30, 41, 59, 0.8)',
      fontWeight: '500',
      backdropFilter: 'blur(10px)',
      transition: 'all 0.3s ease',
      cursor: 'default',
      userSelect: 'none',
    };
  };

  const getIconStyle = () => ({
    width: isMobile ? '12px' : isTablet ? '14px' : '16px',
    height: isMobile ? '12px' : isTablet ? '14px' : '16px',
    flexShrink: 0,
    color: theme === 'dark' ? 'rgba(59, 130, 246, 0.8)' : 'rgba(59, 130, 246, 1)',
  });

  const getTextStyle = () => ({
    lineHeight: '1.4',
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  });

  return (
    <div style={getDisplayStyle()} title={formatDateTime()}>
      <Clock style={getIconStyle()} />
      <div style={getTextStyle()}>
        <div style={{ fontSize: 'inherit' }}>
          {isMobile && window.innerWidth < 900
            ? currentTime.toLocaleTimeString(
              language === 'ar' ? 'ar-EG' : 'en-US',
              { hour: '2-digit', minute: '2-digit' }
            )
            : formatDateTime()}
        </div>
        {/* {!isMobile && isTablet && (
          <div style={{ fontSize: '0.65rem', opacity: 0.7 }}>
            {timezoneName}
          </div>
        )}
        {!isMobile && !isTablet && (
          <div style={{ fontSize: '0.7rem', opacity: 0.7 }}>
            {timezoneName}
          </div>
        )} */}
      </div>
    </div>
  );
};

export default DateTimeDisplay;
